<script lang="ts">
    import { onMount } from 'svelte';

    import { trackEvent } from '@root/src/utils/init-analytics.js';
    import { MODAL_TABS } from '@src/constants/index';

    // store
    import { isCrossModalOpened } from '@src/store/ui';

    import CrossModal from '../../../cross-reusable-components/modals/cross-modal.svelte';
    import CrossModalMenuNavigation from '../../../cross-reusable-components/modals/cross-modal-menu-navigation.svelte';
    import CrossModalContent from '../../../cross-reusable-components/modals/cross-modal-content.svelte';
    import MainMenuTabContent from './main-menu-tab-content.svelte';

    export let musicEnabled = true;
    export let soundEnabled = true;
    export let currentTab;

</script>

{#if $isCrossModalOpened}
    <CrossModal on:close_modal={() => ($isCrossModalOpened = false)}>
        <CrossModalMenuNavigation
            slot="modal-header"
            let:classSlot
            iconClass={classSlot}
            {currentTab}
            on:tab_info={() => (currentTab = MODAL_TABS.INFO)}
            on:tab_setting={() => (currentTab = MODAL_TABS.SETTINGS)}
        />
        <CrossModalContent slot="modal-content">
            <MainMenuTabContent
                {currentTab}
                {musicEnabled}
                {soundEnabled}
                on:fullscreen
                on:musicChange
                on:soundChange
            />
        </CrossModalContent>
    </CrossModal>
{/if}

<style lang="scss">
    :global {
        .svelte-toggle--track {
            background: #252525 !important;
            box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.24);
            border-radius: 32px;
            width: 48px !important;
        }
        .svelte-toggle--thumb {
            background: #252525;
            border-radius: 65.3182px;
            box-shadow: 0px 2px 6px 0px #0000003d inset;
            border: 1px solid transparent !important;
            background-color: #333333 !important;
        }

        .svelte-toggle--checked .svelte-toggle--thumb {
            background: linear-gradient(135deg, #5c9cff 0%, #1f77ff 51.71%, #1f77ff 100%);
            border: none !important;
        }
    }
</style>
